export class DataResponse<T> {

  constructor(
    public data: T,
    public status = RequestStatus.Success,
    public httpReponse?: angular.IHttpPromiseCallbackArg<T>) {}

  isSuccessful() {
    return this.status == RequestStatus.Success;
  }

  isFailure() {
    return this.status = RequestStatus.Failure;
  }

  isValidationSuccessful() {
    return this.status == RequestStatus.ValidationSuccess;
  }

  isValidationFailure() {
    return this.status == RequestStatus.ValidationFailure;
  }
}

export enum RequestStatus {
  Success,
  Failure,
  ValidationFailure,
  ValidationSuccess,
  Unknown
}